var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',[_vm._v(" 用户协议 ")]),_c('el-main',{staticClass:"main"},[_c('div',{staticClass:"text ",attrs:{"id":"u12281_text"},domProps:{"innerHTML":_vm._s(_vm.Info)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }